<template>
    <div class="editar-envasado-producto container mt-4">
      <h3 class="text-primary mb-4">
        <font-awesome-icon icon="box-open" class="me-2" />
        Editar Producto Envasado
      </h3>
  
      <form @submit.prevent="submitForm">
  
        <!-- Información del producto envasado -->
        <div class="mb-4 p-3 bg-light rounded border">
          <div class="row">
            <div class="col-md-6">
              <label class="fw-semibold text-secondary">Tipo de Producto</label>
              <input type="text" class="form-control" :value="form.tipo_producto" readonly>
            </div>
  
            <div class="col-md-6">
              <label class="fw-semibold text-secondary">Código de Envasado</label>
              <input type="text" class="form-control" :value="form.codigo" readonly>
            </div>
            <!-- Aviso importante -->
            <div class="alert alert-warning mt-3 py-2 small" role="alert">
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" class="me-2" />
                <strong>Importante:</strong> Las cantidades y peso no se pueden editar. Para hacer ajustes en cantidad, debe anular este envasado y crear uno nuevo.
            </div>
          </div>
        </div>
  
        <!-- Tipo de Envase -->
        <div class="mb-4 p-3 bg-light rounded border">
          <label class="fw-semibold text-secondary">Tipo de Envase</label>
          <input type="text" v-model="envaseBuscar" class="form-control mb-2" placeholder="Buscar envase...">
          <select v-model="form.tipo_envase" class="form-select" required>
            <option value="">Seleccione tipo de envase</option>
            <option v-for="envase in envasesFiltrados" :key="envase.id" :value="envase.id">
              {{ envase.descripcion }}
            </option>
          </select>
        </div>
  
        <!-- Fechas -->
        <div class="row g-3 mb-4 p-3 bg-light rounded border">
          <h6 class="text-primary">Fechas</h6>
  
          <div class="col-md-4">
            <label>Fecha de Envasado</label>
            <input v-model="form.fecha_envasado" type="date" class="form-control" required>
          </div>
  
          <div class="col-md-4">
            <label>Días hasta Vencimiento</label>
            <input v-model.number="form.dias_vencimiento" type="number" min="0" class="form-control" @input="calcularFechaVencimiento">
          </div>
  
          <div class="col-md-4">
            <label>Fecha de Vencimiento</label>
            <input v-model="form.fecha_vencimiento" type="date" class="form-control" @input="calcularDiasVencimiento">
          </div>
        </div>
  
        <!-- Observaciones -->
        <div class="mb-4">
          <label>Observaciones</label>
          <textarea v-model="form.observaciones" class="form-control" rows="3"></textarea>
        </div>
  
        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-outline-secondary" @click="$emit('cancelar')">Cancelar</button>
          <button type="submit" class="btn btn-primary">Guardar Cambios</button>
        </div>
  
      </form>
    </div>
  </template>
  
  <script>
  import axios from '@/axios';
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
  
  export default {
    name: "FormProductoFinalEnvasadoEditar",
    components: { FontAwesomeIcon },
    props: {
      envasado: { type: Object, required: true }
    },
    data() {
      return {
        envaseBuscar: '',
        tiposEnvases: [],
        form: {
          tipo_producto: this.envasado.tipo_producto,
          tipo_envase: this.envasado.tipo_envase,
          fecha_envasado: this.envasado.fecha_envasado?.substr(0, 10),
          fecha_vencimiento: this.envasado.fecha_vencimiento?.substr(0, 10),
          dias_vencimiento: null,
          codigo: this.envasado.codigo,
          observaciones: this.envasado.observaciones
        },
        clubActual: this.$store.getters.getClubActual
      };
    },
    computed: {
      envasesFiltrados() {
        return this.tiposEnvases.filter(envase =>
          envase.descripcion.toLowerCase().includes(this.envaseBuscar.toLowerCase())
        );
      }
    },
    methods: {
      async fetchData() {
        try {
          const res = await axios.get('/api/constantes/tipos_de_envases');
          this.tiposEnvases = res.data;
          this.calcularDiasVencimiento();
        } catch (error) {
          console.error('Error al cargar datos:', error);
        }
      },
  
      calcularFechaVencimiento() {
        if (this.form.fecha_envasado && this.form.dias_vencimiento != null) {
          const fecha = new Date(this.form.fecha_envasado);
          fecha.setDate(fecha.getDate() + this.form.dias_vencimiento);
          this.form.fecha_vencimiento = fecha.toISOString().substr(0, 10);
        }
      },
  
      calcularDiasVencimiento() {
        if (this.form.fecha_envasado && this.form.fecha_vencimiento) {
          const inicio = new Date(this.form.fecha_envasado);
          const fin = new Date(this.form.fecha_vencimiento);
          const diff = Math.ceil((fin - inicio) / (1000 * 60 * 60 * 24));
          this.form.dias_vencimiento = diff;
        }
      },
  
      async submitForm() {
        try {
          await axios.put(`/api/producto_final_envasado/${this.envasado.id}`, {
            club_id: this.clubActual.id,
            ...this.form,
            fecha_envasado: new Date(this.form.fecha_envasado),
            fecha_vencimiento: new Date(this.form.fecha_vencimiento)
          });
  
          alert('Cambios guardados correctamente.');
          this.$emit('cancelar');
  
        } catch (error) {
          console.error('Error al editar producto envasado:', error);
          alert('Error al guardar cambios.');
        }
      }
    },
  
    mounted() {
      this.fetchData();
    }
  };
  </script>
  
  <style scoped>
  .editar-envasado-producto {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0,0,0,0.05);
  }
  
  .bg-light {
    background-color: #f8f9fa !important;
  }
  
  .fw-semibold {
    font-weight: 600;
  }

  .alert-warning {
  background-color: #fff3cd;
  border-color: #ffeeba;
  color: #856404;
}

  </style>
  